const _ = require('underscore');

const PlansEditService = (function (root, doc, undefined) {

    /**
     * Returns plan position in the plans Array
     * @param {Array} plans
     * @param {Integer || null} targetMonth
     */
    const getPlanPosition = (plans, targetMonth) => {
        const index = _.findIndex(plans, (item) => item.plan.months === targetMonth);
        return index !== -1 ? index : null;
    };

    /**
     * Removes the one month plan
     * @param {Array} plans
     * @param {Number} targetMonth
     */
    const removeMonthPlan = (plans, targetMonth) => {
        const position = getPlanPosition(plans, targetMonth);
        if (position !== null) {
            plans.splice(position, 1);
        }
        return plans;
    };

    return {
        removeMonthPlan: removeMonthPlan
    };

})(window, document);

module.exports = PlansEditService;
